import React, { useState } from 'react';
import { ProductOpenTable } from '../ProductOpenTable/ProductOpenTable.tsx';
import { ArrowButton } from '../../../../ui/General/ArrowButton/ArrowButton.tsx';
import { CarBrands } from '../../../../types/ApplicabilityCar.interface.ts';
import { cn } from '../../../../utils/cn.ts';

type Props = {
    applicability: CarBrands
}

/**
 * Блок с применимостью товара
 * @returns 
 */
export const ProductApplicability: React.FC<Props> = ({ applicability }) => {
    return (
        <ProductOpenTable title='Применимость'>
            <div className='border rounded-xl bg-white divide-y mt-2 slide-down-element'>
                {Object.keys(applicability).map((brand, index) => {
                    const [isOpen, setIsOpen] = useState(false);
                    const models = applicability[brand as keyof typeof applicability];

                    return (
                        <div key={brand + index} className={cn('slide-down', isOpen && 'active')}>
                            <button className='w-full bs-bb flex justify-between items-center px-4 py-2 font-semibold text-left hover:bg-orange-50 transition'
                                onClick={() => setIsOpen(!isOpen)}>
                                <span>{brand}</span>
                                <span className='ml-2'><ArrowButton state={isOpen ? 'up' : 'down'} /></span>
                            </button>
                            <div className='px-4 pb-2 slide-down-element'>
                                {Object.keys(models).length > 0 && [Object.keys(models)?.[0]].map((model, index) => {
                                    const modelData = models[model as keyof typeof models] as { bodies: string[]; engines: string[] };

                                    let bodies = '';
                                    let engines = '';

                                    if (modelData.bodies.length > 0 || modelData.engines.length > 0) {
                                        bodies = (modelData.bodies.join(', '));
                                        engines = (modelData.engines.join(', '));
                                    }

                                    return (bodies || engines) &&
                                        <table key={model + index} className='w-full text-sm'>
                                            <thead>
                                                <tr className='text-gray-500'>
                                                    <th className='text-left py-1 pr-4'
                                                        style={{ width: '66.6666667%', maxWidth: '66.6666667%' }}>
                                                        Кузов
                                                    </th>
                                                    <th className='text-left py-1'
                                                        style={{ width: '33.3333333%', maxWidth: '33.3333333%' }}>
                                                        Двигатель
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className='py-1 pr-4 text-xs'
                                                        style={{ width: '66.6666667%', maxWidth: '66.6666667%' }}>
                                                        {bodies}
                                                    </td>
                                                    <td className='py-1 text-xs'
                                                        style={{ width: '33.3333333%', maxWidth: '33.3333333%' }}>
                                                        {engines}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>;
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </ProductOpenTable>
    );
}